export enum UserAccessType {
   NO_ACCESS,
   READ,
   WRITE
}
